// extracted by mini-css-extract-plugin
export default {"popup":"chatConfirmationPopup_popup__EjmfA","popup__title":"chatConfirmationPopup_popup__title__o1DQR","popup__nextBtn":"chatConfirmationPopup_popup__nextBtn__I65iT"};